import * as React from 'react'

import UGLibWidgets from 'src/uglib_components/uglibWidgets'

import { contentExists } from 'src/utils/ug-utils'
import {process_inline_images, get_labelled_field, get_optional_field} from 'src/uglib_utils/utils'

import SidebarLayout from 'src/uglib_components/sidebarLayout'

const Page = ({pageContext}) => {

    const pageData = pageContext.node;
    const hero_data = pageData.relationships.field_media_image;

    let hero_image = null; 
    if(hero_data !== null) {
        const row = {
            node: {
                relationships: hero_data.relationships,
                field_media_image: {alt: hero_data.field_media_image.alt}
            },
        }
        hero_image = [row];
    }
    const files = pageContext.files;
    
	const nodeID = pageData.drupal_internal__nid;
	const keywords = pageData.relationships.field_keywords.map(function(element) {return element.name})
	const title = pageData.title;
    
	/****
    WidgetData contains all widgets (paragraphs) that are available - when adding a new widget, validate that the correct items are selected using a comparison to __typename.  This will be paragraph__WIDGETNAME - you can pass the widgetsData variable through to your component. 
    ****/

    const widgetsData = (contentExists(pageData.relationships.field_widgets) ? pageData.relationships.field_widgets : null);

	let body = <></>;
	if (pageData.body !== null) {
		const original_body = pageData.body.processed;
		
		body = process_inline_images(original_body, files);
	}

    const attribution = <span className="attribution">{ get_labelled_field(get_optional_field(pageData, 'field_attribution.processed')) } </span>
    const license = get_labelled_field(get_optional_field(pageData, 'relationships.field_content_license.description.processed'), <h2>License</h2>);

    return (
        <SidebarLayout nodeID={nodeID} path={pageData.path.alias} title={title} keywords={keywords} images={hero_image} applyStyles={true}>
        {/* <SidebarLayout nodeID={nodeID} title={title} keywords={keywords} applyStyles={true}> */}

            { attribution }
			
			{ /**** Legacy body field ****/}
			{body}

			{ /**** New widget-based body field ****/}
			<UGLibWidgets pageData={widgetsData} />

            { license }
        </SidebarLayout>
    )
}

export default Page